import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export const PrivacyPolicy = () => {
    return (<>
        <Navbar />
        <div className="w-4/5 mx-auto my-12">
            <div className="mt-4">
                <h1 className="text-2xl font-medium">Fishcord Privacy Policy</h1>
                <h2 className="text-lg">Last Updated: February 26, 2025</h2>
                <p>Your privacy is important to us. This Privacy Policy explains how Fishcord collects, uses, and protects your data when you use our bot.</p>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">1. Data We Collect</h2>
                <ul className="list-disc pl-6">
                    <li>Fishcord collects Discord user IDs, server IDs, and fishing-related statistics to provide its features.</li>
                    <li>Users have the option to upload photos, but this is not required. If a photo is uploaded, it is securely stored on Google Cloud Storage and is not publicly accessible.</li>
                    <li>We do not collect personal information such as email addresses, phone numbers, or real names.</li>
                    <li>Use of the Fishcord bot does not require or collect any personal information. However, if you log in to our website to use the web app, we use your email for authentication through our provider, Supabase. We do not store or use your email beyond authentication purposes.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">2. How We Use Your Data</h2>
                <ul className="list-disc pl-6">
                    <li>Data is used solely to enable bot functionality, such as tracking user catches and displaying leaderboards.</li>
                    <li>We do not sell, trade, or share user data with third parties.</li>
                    <li>Data is stored securely and only retained as long as necessary for the bot's functionality.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">3. Data Security</h2>
                <ul className="list-disc pl-6">
                    <li>We take appropriate measures to protect user data from unauthorized access, loss, or misuse.</li>
                    <li>Access to stored data is restricted and used only for maintaining and improving Fishcord.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">4. User Rights & Data Removal</h2>
                <ul className="list-disc pl-6">
                    <li>Users can request the removal of their data by contacting us.</li>
                    <li>If you leave a server where Fishcord is used, your data may still be retained unless a deletion request is made.</li>
                    <li>Server administrators can request the removal of their server's data.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">5. Changes to This Policy</h2>
                <ul className="list-disc pl-6">
                    <li>We may update this Privacy Policy from time to time. Continued use of Fishcord after changes means you accept the updated policy.</li>
                </ul>
            </div>

            <div className="mt-4">
                <h2 className="text-lg font-medium">6. Contact Information</h2>
                <p>If you have any questions or requests regarding this Privacy Policy, please get in contact <a className="text-blue-500 underline" href="https://discord.com/invite/BsCvg3Z23k" target="_blank" rel="noopener noreferrer">here</a>.</p>
            </div>
        </div>
        <Footer />
    </>
    );
};